export default "__VITE_ASSET__7b8a338e__"